import { createAsyncThunk } from "@reduxjs/toolkit";
import { CreditState } from "../credit-state.interface";
import { rejectCatchError } from "../../reject-catch-error";
import axios from "axios";
import { environment } from "environments/environment";
import { RootState } from "../../product/product.store";
import { useSelector } from "react-redux";

export const createOrderThunk = createAsyncThunk<void>(
    'credits/createOrder',
    async (_, { dispatch, getState, rejectWithValue }) => {
        const state = (getState() as RootState).credit;
        
        const user = state.user;
        console.log("User coment:", user.commentary);

        try {
            const result = await axios.post(`${ environment.urls.credits.order }`, {
                productId: state.productId,
                credit: state.selectCredit?.id,
                month: state.selectMonth?.id,
                avanse: state.avanse,
                user: {
                    ...state.user,
                    phone: state.confirmedPhone
                },
                shipping: {
                    method: state.shipping.selectShippingMethod?.code,
                    zone: state.shipping.shippingZone,
                    pickup: state.shipping.shippingPickup,
                    city: state.shipping.shippingCity,
                    cityId: state.shipping.shippingCityId,
                    address: state.shipping.shippingAddress
                },
                subscription: state.selectSubscription || null,
                starnet: {
                    city: state.selectStarnetCity || null,
                    region: state.selectStarnetRegion || null,
                    address: state.selectStarnetAddress || null,
                },
                marketing: state.marketing,
                terms: state.terms,
                contactMethod: state.contactMethod || null,
            });
            return result.data;
        } catch (error: any) {
            return rejectCatchError(error, rejectWithValue);
        }
    }
);